<template>
  <div class="copy-week text-dark no-print" v-on-clickaway="close">
    <CopyCalendarRotate
      v-if="isShowCopyCalendarRotate"
      :calendarId="calid"
      :activeCalendarDate="activeCalendarDate">
    </CopyCalendarRotate>
    <!-- Buttons -->
    <template v-else>
      <button @click="getCopyDate"
              v-if="!isShowCopyCalendarRotate"
              :class="[
                {'do-bttn': activeCalendarDate},
                {'inactive': modal},
              {'hint--left hint--always': isJustCopied}
              ]"
              :aria-label="tooptipCopyWeek">
        {{ $t('vue2.copycalendar.copy') }}
        <span class="icon-arrow-down5"></span>
      </button>
      <button v-if="currentDateIsNotWithinCalendarRange"
              :class="{'do-bttn': activeCalendarDate}"
              @click="submitThisWeek">
        {{ $t('vue2.copycalendar.pasteThisWeek') }}
      </button>
    </template>
    <!-- Modal -->
    <transition name="fadeInDown">
      <div class="week-picker" v-if="modal">
        <div class="week-picker__inner">
          <div class="week-picker__header">
            <div class="week-picker__header__left">
              <h2 class="text-blue">
                {{ selectedWeeks.length }}
                <span v-if="selectedWeeks.length === 1">{{ $t('vue2.copycalendar.weekSelected') }}</span>
                <span v-else>{{ $t('vue2.copycalendar.weeksSelected') }}</span>
              </h2>
              <a target="_blank" v-if="schoolIsFromDenmark" class="label-link" href="https://docendohelp.crisp.help/da/article/kopiering-af-uger-i-skemaerkalendere-1tka0r4/?bust=1737554247682">
                <label class="do-pill animateFast fadeInLeftCustom">
                  <span class="label-text">Bemærk: Kopierer kun brikker lagt i denne kalender</span>
                  <span class="icon-question3 marg-1-left"></span> </label>
              </a>
            </div>
            <div class="icon__bg-circle icon__bg-circle__close" @click="close">
              <span class="icon-cross2"></span>
            </div>
          </div>
          <div class="week-picker__content flex">
            <div class="content">
              <div class="number hint--top"
                   :aria-label="week.date | tooltipDate"
                   :class="[{'isSelected': week.isSelected}, {'isCopyWeek': week.isCopyWeek}]"
                   v-for="(week, index) in weeks"
                   :key="week.serverDate"
                   @click="toggleWeek(index)">
            <span :class="{'isNow': week.isNow}">
              {{ week.weekNum }}
            </span>
              </div>
            </div>

            <div class="sidebar">
              <ul>
                <li class="sidebar__headline">
                  <b>{{ $t('vue2.copycalendar.markWeeksFrom') }}
                    <div class="no-tag" :class="{'tag': !showStartPasteWeek}">
                      {{ startPasteWeek | week }}
                      <span class="icon-cross2 pointer"
                            v-show="!showStartPasteWeek"
                            @click.stop="eraseStartDate">
                    </span>
                    </div>
                  </b>
                  <li>
              <span class="sidebar__clickable"
                    @click="selectAll">
                <span class="bttn width-100 btn-trans">
                {{ $t('vue2.copycalendar.allWeeks') }}
                  </span>
              </span>
                  </li>
                  <li>
              <span class="sidebar__clickable"
                    @click="selectOddWeeks">
                 <span class="bttn width-100 btn-trans">
                {{ $t('vue2.copycalendar.oddWeeks') }}
                 </span>
              </span>
                  </li>
                  <li>
              <span class="sidebar__clickable"
                    @click="selectEvenWeeks">
                 <span class="bttn width-100 btn-trans">
                {{ $t('vue2.copycalendar.evenWeeks') }}
                 </span>
              </span>
                  </li>
                  <li>
              <span class="sidebar__clickable"
                    @click="removeAllSelectedWeeks">
                 <span class="bttn btn-trans width-100 btn-remove">
                {{ $t('vue2.copycalendar.unselectAll') }}
                 </span>
              </span>
                  </li>
              </ul>
            </div>
          </div>
          <!-- FOOTER -->
          <div class="week-picker__footer">
            <div class="delete-option">
              <label for="checkbox">
                <span>{{ $t('vue2.copycalendar.deleteLessonsInSelectedWeeks') }}</span>
                <span v-if="calType === 'user'"> ({{ $t('vue2.copycalendar.absenceWillNotBeDeleted') }})</span>
              </label>
              <input type="checkbox" id="checkbox" v-model="deleteEvents"/>
            </div>
            <button @click="submitWeeks"
                    class="bttn--submit"
                    :class="{'inactive': noneSelected || notSubmit }">
              <span>{{ $t('vue2.copycalendar.paste') }}</span>
            </button>
          </div>
        </div>
        <left-panel
          :deleteEvents="deleteEvents"
          :selectedWeeks="selectedWeeks"
          :calId="calid"
          @load="setSubmit">
        </left-panel>
      </div>
    </transition>
  </div>
</template>

<script>
import eventbus from '../../eventbus'
import docendo from '../../docendo'
import moment from 'moment'
import {mixin as clickaway} from 'vue-clickaway'
import leftPanel from './Feedback'
import spinner from '../common/SpinnerButton'
import CopyCalendarRotate from '../CopyCalendarRotate/CopyCalendarRotate'

export default {
  props: {
    calid: {
      default: 71980
    },
    initCalendar: {
      default: null
    },
    activeCalendarDate: {
      default: null
    }
  },
  mixins: [clickaway],
  components: {CopyCalendarRotate, leftPanel, spinner},
  data () {
    return {
      cal: null,
      calType: '',
      calCurrentDate: moment(),
      modal: false,
      copyDate: '',
      isJustCopied: false,
      selectedWeeks: [],
      startPasteWeek: eventbus.now,
      feedback: false,
      notSubmit: false,
      deleteEvents: true,
      weeks: [],
      isLoading: false,
      calStartDate: moment().format('YYYY-MM-DD'),
      calEndDate: moment().format('YYYY-MM-DD')
    }
  },
  computed: {
    activeSchool () {
      return this.$store.state.activeSchool
    },
    schoolIsFromDenmark () {
      return this.activeSchool && this.activeSchool.country === 'DK'
    },
    schoolFeatures () {
      return this.activeSchool && this.activeSchool.features ? this.activeSchool.features : []
    },
    isShowCopyCalendarRotate () {
      return this.schoolFeatures.indexOf('rotating_schedules') > -1
    },
    activeSchoolYears () {
      return this.$store.state.activeSchoolYears
    },
    schoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    isBetweenActiveSchoolYear () {
      let calDateIsWithinThisSchoolYear = null
      this.activeSchoolYears.forEach(year => {
        let startDate
        let endDate
        if (this.calType === 'klass') {
          startDate = moment(year.student_time_start).startOf('isoweek')
          endDate = moment(year.student_time_end).endOf('isoweek')
        } else {
          startDate = moment(year.employee_time_start).startOf('isoweek')
          endDate = moment(year.employee_time_end).endOf('isoweek')
        }
        if (moment(this.calCurrentDate).isSame(startDate) || moment(this.calCurrentDate).isBetween(startDate, endDate)) {
          calDateIsWithinThisSchoolYear = year
        }
      })
      return calDateIsWithinThisSchoolYear
    },
    currentDateIsNotWithinCalendarRange () {
      return !this.isBetweenActiveSchoolYear && this.activeSchoolYears.length > 0
    },
    showStartPasteWeek () {
      return moment(this.startPasteWeek).isSame(this.calStartDate)
    },
    noneSelected () {
      return this.selectedWeeks.length === 0
    },
    tooptipCopyWeek () {
      return this.$t('vue2.copycalendar.copiedFrom') + ' ' + moment(this.copyDate).isoWeek()
    },
    firstDayOfTheWeek () {
      return this.$store.getters.firstDayOfWeek
    }
  },
  watch: {
    activeCalendarDate () {
      this.calCurrentDate = this.activeCalendarDate
    }
  },
  filters: {
    tooltipDate (date) {
      let start = moment(date)
      let start2 = moment(date).format('DD. MMM')
      let startFormat = start.format('DD')
      let end = moment(date).add(6, 'days')
      let endFormat = moment(date).add(6, 'days').format('DD. MMM YYYY')
      // If same month
      if (moment(start).format('MM') === moment(end).format('MM')) {
        return startFormat + ' - ' + endFormat
      } else {
        return start2 + ' - ' + endFormat
      }
    },
    week (date) {
      return moment(date).isoWeek()
    }
  },
  methods: {
    getCalType () {
      if (this.initCalendar) {
        this.cal = this.initCalendar
        this.calType = this.initCalendar.type
      } else {
        docendo.calendar(this.calid, data => {
          this.cal = data
          this.calType = data.type
        })
      }
    },
    getCopyDate () {
      let year = this.schoolYear
      if (this.isBetweenActiveSchoolYear) {
        year = this.isBetweenActiveSchoolYear
      }
      if (this.calType === 'klass') {
        this.calStartDate = year.student_time_start
        this.calEndDate = year.student_time_end
      } else {
        this.calStartDate = year.employee_time_start
        this.calEndDate = year.employee_time_end
      }
      // Remove settings before
      this.removeAllSelectedWeeks()
      this.cleanCopyDate()
      if (this.activeCalendarDate) {
        this.isJustCopied = true
        setTimeout(() => {
          // Remove tooltip after 2 seconds
          this.isJustCopied = false
        }, 3500)
        this.copyDate = moment(this.activeCalendarDate).isoWeekday(this.firstDayOfTheWeek)
      } else {
        // For ROR calendar date
        let calendar = document.querySelectorAll('#calendar_' + this.calid)
        if (calendar.length === 1) {
          this.isJustCopied = true
          setTimeout(() => {
            // Remove tooltip after 2 seconds
            this.isJustCopied = false
          }, 3500)
          this.copyDate = calendar[0].dataset.current_date
        }
      }
      this.openModal()
    },
    openModal () {
      this.isLoading = true
      this.createWeeks()
      this.getPasteDate()
      this.modal = true
      this.$emit('copyCalendarModalOpen', true)
    },
    createWeeks () {
      const start = moment(this.calStartDate).day(this.firstDayOfTheWeek)
      const end = moment(this.calEndDate).endOf('isoweek')
      const startWeek = moment(start).isoWeek()
      const diff = moment(end).diff(start, 'week')
      const max = startWeek + diff
      let weeks = []
      for (let i = startWeek; i <= max; i++) {
        let date = moment(start).isoWeek(i).day(this.firstDayOfTheWeek)
        weeks.push({
          date: date,
          isSelected: false,
          serverDate: moment(date).format('YYYY-MM-DD'),
          weekNum: date.isoWeek(),
          isNow: moment(date).format('GGGG-WW') === moment().format('GGGG-WW'),
          isCopyWeek: date.isoWeek() === moment(this.copyDate).isoWeek()
        })
      }
      this.weeks = weeks
      this.isLoading = false
    },
    setSubmit (val) {
      this.notSubmit = val
    },
    getPasteDate () {
      if (this.activeCalendarDate) {
        const week = moment(this.activeCalendarDate).isoWeek()
        this.startPasteWeek = this.activeCalendarDate
        this.selectWeek(this.findWeek(week))
      } else {
        // For ROR
        let calendar = document.querySelectorAll('#calendar_' + this.calid)
        if (calendar.length === 1 && this.selectedWeeks.length === 0) {
          let week = moment(calendar[0].dataset.current_date).isoWeek()
          this.startPasteWeek = calendar[0].dataset.current_date
          this.selectWeek(this.findWeek(week))
        }
      }
    },
    selectWeek (i) {
      if (i > -1) {
        if (!this.weeks[i].isSelected && !this.weeks[i].isCopyWeek) {
          this.selectedWeeks.push(this.weeks[i].serverDate)
          this.weeks[i].isSelected = true
        }
      }
    },
    removeWeek (i) {
      this.weeks[i].isSelected = false
      let selectedIndex = this.selectedWeeks.indexOf(this.weeks[i].serverDate)
      this.selectedWeeks.splice(selectedIndex, 1)
    },
    toggleWeek (index) {
      if (this.selectedWeeks.length < 1 || this.showStartPasteWeek) {
        this.startPasteWeek = this.weeks[index].date
      }
      if (!this.weeks[index].isSelected) {
        this.selectWeek(index)
      } else {
        this.removeWeek(index)
      }
    },
    findWeek (weekNum) {
      for (let i = 0; i < this.weeks.length; i++) {
        if (this.weeks[i].weekNum === weekNum) {
          return i
        }
      }
    },
    selectAll () {
      for (let i = 0; i < this.weeks.length; i++) {
        if (moment(this.weeks[i].date).isSameOrAfter(this.startPasteWeek)) {
          this.selectWeek(i)
        }
      }
    },
    selectEvenWeeks () {
      for (let i = 0; i < this.weeks.length; i++) {
        if (moment(this.weeks[i].date).isSameOrAfter(this.startPasteWeek)) {
          if (this.isEven(this.weeks[i].date.isoWeek())) {
            this.selectWeek(i)
          }
        }
      }
    },
    selectOddWeeks () {
      for (let i = 0; i < this.weeks.length; i++) {
        if (moment(this.weeks[i].date).isSameOrAfter(this.startPasteWeek)) {
          if (this.isOdd(this.weeks[i].date.isoWeek())) {
            this.selectWeek(i)
          }
        }
      }
    },
    isEven (n) {
      return /^-?\d*[02468]$/.test(n)
    },
    isOdd (n) {
      return /^-?\d*[13579]$/.test(n)
    },
    removeAllSelectedWeeks () {
      this.selectedWeeks = []
      for (let i = 0; i < this.weeks.length; i++) {
        this.weeks[i].isSelected = false
      }
    },
    submitWeeks () {
      this.$store.dispatch('analyticsCopyCalender')
      if (this.selectedWeeks.length > 0 && !this.notSubmit) {
        this.close()
        eventbus.toast = {text: this.$i18n.t('vue2.copycalendar.noticationMessage'), success: false}
        docendo.calendarCopyWeeks(this.calid, this.copyDate, this.selectedWeeks, this.deleteEvents, [], ['absence', 'presence', 'activity'], data => {
          this.removeAllSelectedWeeks()
        })
      }
    },
    submitThisWeek () {
      this.$store.dispatch('analyticsCopyCalender')
      this.close()
      eventbus.toast = {text: this.$i18n.t('vue2.copycalendar.noticationMessage'), success: false}
      const serverDate = moment(this.calCurrentDate).format('YYYY-WW')
      this.selectedWeeks.push(serverDate)
      docendo.calendarCopyWeeks(this.calid, this.copyDate, this.selectedWeeks, false, [], ['absence', 'presence', 'activity'], data => {
        this.removeAllSelectedWeeks()
      })
    },
    close () {
      this.modal = false
      this.feedback = false
      this.$emit('copyCalendarModalOpen', false)
    },
    eraseStartDate () {
      this.startPasteWeek = this.calStartDate
    },
    cleanCopyDate () {
      this.copyDate = ''
      for (let i = 0; i < this.weeks.length; i++) {
        this.weeks[i].isCopyWeek = false
      }
    }
  },
  beforeMount () {
    this.getCalType()
  },
  mounted () {
    if (this.activeCalendarDate) {
      this.calCurrentDate = this.activeCalendarDate
    } else {
      // Listen for the ROR FullCalendar-event
      window.addEventListener('fullcal_view_or_date_changed', e => {
        this.calCurrentDate = e.detail
      }, false)
    }
  }
}
</script>

<style scoped>
@import '../../assets/css/variables.css';

.copy-week {
  position: relative;
  display: inline-flex;
  z-index: 2;
  gap: 0.5rem;
}

.passive {
  opacity: 0.5;
}

.week-picker {
  background-color: #fff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, .21);
  border: 1px solid #e6e8eb;
  right: 0;
  position: absolute;
  top: calc(100% + 4px);
  width: 600px;
  z-index: 300;
  border-radius: 4px;
}

.week-picker__inner {
  position: relative;
  z-index: 100;
  box-shadow: inset 0 0 0 1px #e6e8eb;
}

.arrow {
  height: 0;
  width: 0;
  border: 6px solid transparent;
  border-bottom-color: #fafafa;
  right: 12px;
  position: absolute;
  top: -12px
}

.week-picker__content {
  background: white;
}

.week-picker__header, .week-picker__footer {
  align-items: center;
  background-color: #fafafa;
  display: flex;
  padding: 10px 20px;
  height: 50px;
  justify-content: space-between;
  align-items: center;
}

.week-picker__header {
  box-shadow: inset 0 -1px 0 0 #e6e8eb;
  border-radius: 4px 4px 0 0;
}

.week-picker__footer {
  box-shadow: inset 0 1px 0 0 #e6e8eb;
  justify-content: flex-end;
  border-radius: 0 0 4px 4px;
}

.week-picker__footer > p {
  margin-right: 7px;
}

.week-picker__footer > button {
  margin-left: 15px;
}

.sidebar {
  position: absolute;
  top: 50px;
  bottom: 50px;
  right: 0;
  width: 190px;
  border-left: 1px solid #e4e4e4;
  box-sizing: border-box;
  background-color: #fafafa;
  overflow: auto;
}

.sidebar__headline {
  padding-left: 15px;
}

.sidebar li {
  align-items: center;
  box-shadow: inset 0 -1px 0 0 rgba(226, 230, 234, .45);
  display: flex;
  height: 50px;
  position: relative;
}

.sidebar li > .sidebar__clickable {
  cursor: pointer;
  display: flex;
  flex: 1;
  height: 100%;
  align-items: center;
  padding: 0 15px;
  transition: 0.3s;
}

.sidebar li > .sidebar__clickable:active {
  transform: scale(.9);
}

.sidebar ul {
  margin: 0;
}

.content {
  margin-right: 190px;
  flex-wrap: wrap;
  display: flex;
  width: 418px;
  padding: 3px;
  justify-content: center;
}

.number {
  padding: 0 10px;
  height: 42px;
  width: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2px;
  cursor: pointer;
  border-radius: 50%;
  border: 1px solid #edf0f5;
  user-select: none;
  transition: 0.25s;
}

.number:hover {
  border-color: var(--blue);
}

.number:active {
  transform: scale(.9);
}

.isSelected {
  background-color: var(--blue);
  color: white;
}

.isNow:after {
  content: '';
  z-index: 100;
  background: var(--blue);
  border-radius: 50%;
  display: block;
  height: .5em;
  left: 50%;
  margin: 0em 0 0 -0.22em;
  position: absolute;
  width: .5em;
}

.isSelected .isNow:after, .isCopyWeek .isNow:after {
  background: white;
}

.isCopyWeek {
  background: var(--dark-blue) !important;
  color: white !important;
  border: none !important;
}

.tag {
  color: var(--blue);
  background: white;
  border-radius: 6px;
}

.no-tag {
  top: 14px;
  right: 15px;
  position: absolute;
  padding: 0 6px;
  font-size: 15px;
}

.no-tag > span {
  position: relative;
  top: 1px;
  right: 0;
}

.btn-remove {
  color: var(--danger);
}

.submit-message {
  margin: 20px auto;
  font-size: 14px;
}

.submit-message > h2 {
  color: var(--blue);
}

.submit-message__icon {
  font-size: 40px;
  color: var(--blue);
}

.delete-option {
  display: flex;
  align-items: center;
}

.delete-option > * {
  cursor: pointer;
}

.delete-option > label {
  user-select: none;
  font-weight: normal;
}

.delete-option > input {
  margin-left: 2px;
}

.icon__bg-circle__close > span {
  opacity: 0.5;
}

.bttn--submit {
  transition: background 0.25s;
}

.bttn--submit:not(.inactive) {
  background: var(--blue) !important;
  color: #fff;
  box-shadow: 0 2px 2px rgba(0, 0, 0, .1);
  border-color: transparent;
}

.week-picker__header__left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.do-pill {
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  background-color: #fefce8;
  color: #854d0f;
  padding: 4px 8px;
  font-weight: normal;
  font-style: italic;
  border: 1px solid #f4e6c0;
  font-size: 11px;
  text-transform: initial;
}

@keyframes fadeInLeftCustom {
  from {
    opacity: 0;
    transform: translateX(-1rem);
  }

  to {
    opacity: 1;
    transform: none;
  }
}

.fadeInLeftCustom {
  animation-name: fadeInLeftCustom;
}

.label-link {
  cursor: pointer;
}

.label-link:hover label {
  cursor: pointer;
}

.label-link:hover label > .label-text {
  text-decoration: underline;
}

</style>



// WEBPACK FOOTER //
// CopyCalendar.vue?5293d74f